<template>
  <div class="mTable" :style="{height: tBodyHeight + 'px'}">

    <!--表头-->
    <div ref="mTableHead" class="mTable-head" style="overflow: hidden;">
      <ul class="mTable-head-wrap clearfix">
        <!--全选按钮-->
        <li class="mTable-cell mTable-cell-first">
          <div class="mTable-cell-wrap">
            <label class="form-label form-label-tableHead">
              <input type="checkbox" v-model="allChecked" @click="handleAllCheckbox">
            </label>
          </div>
        </li>
        <!--左侧冻结按钮表头(占位作用,被遮挡的)-->
        <li v-for="menu in leftFixMenus"
            :style="{width: tableMenuWidthMap[menu.text] + 'px'}"
            class="mTable-cell mTable-cell-medium">
          <div class="mTable-cell-wrap">
            <span class="mTable-txt">{{ menu.title }}</span>
          </div>
        </li>
        <!--左侧冻结列表头(占位作用,被遮挡的)-->
        <li v-for="(column, i) in leftFixColumns"
            class="mTable-cell mTable-cell-medium fix"
            :class="getHeaderClass(column)"
            :style="{width: (column.width ? column.width : tableColumnWidthMap[column.dataIndex]) + 'px'}"
        >
          <div class="mTable-cell-wrap">
          <span @click="handleOrder(column)" :class="getColumnOrder(column)" class="mTable-txt">{{ column.name }}
            <span class="mTable-sort"><i class="mng icon-descending"></i></span>
          </span>
          </div>
        </li>
        <!-- 左侧插槽表头 -->
        <slot name="headerColumns"></slot>
        <!-- 左侧非冻结按钮表头 -->
        <li v-for="menu in leftUnfixMenus"
            :style="{width: tableMenuWidthMap[menu.text] + 'px'}"
            class="mTable-cell mTable-cell-medium">
          <div class="mTable-cell-wrap">
            <span class="mTable-txt">{{ menu.title }}</span>
          </div>
        </li>
        <!--非冻结列表头-->
        <li v-for="(column, i) in myDragColumns"
            :key="column.dataIndex"
            class="mTable-cell mTable-cell-medium grid-column"
            :class="getHeaderClass(column)"
            :style="{width: (column.width ? column.width : tableColumnWidthMap[column.dataIndex]) + 'px'}"
            @mousemove="handleMouseMove($event, column)"
            @mouseout="handleMouseOut()"
            @mousedown="handleMouseDown($event, column)"
        >
          <div class="mTable-cell-wrap">
						<span @click="handleOrder(column)" :class="getColumnOrder(column)" class="mTable-txt">{{ column.name }}
							<span class="mTable-sort"><i class="mng icon-descending"></i></span>
						</span>
          </div>
        </li>
        <!--右侧非冻结按钮表头-->
        <li v-for="menu in rightUnfixMenus"
            :style="{width: tableMenuWidthMap[menu.text] + 'px'}"
            class="mTable-cell mTable-cell-medium">
          <div class="mTable-cell-wrap">
            <span class="mTable-txt">{{ menu.title }}</span>
          </div>
        </li>
        <li class="mTable-cell" v-if="isShowChange(magicalMenuCodes)">
          <div class="mTable-cell-wrap">
            <span class="mTable-txt">查看数据历史</span>
          </div>
        </li>
        <!--右侧插槽表头-->
        <slot name="lastHeaderColumns"></slot>
        <!--右侧冻结按钮表头(占位作用,被遮挡的)-->
        <li v-for="menu in rightFixMenus"
            :style="{width: tableMenuWidthMap[menu.text] + 'px'}"
            class="mTable-cell mTable-cell-medium">
          <div class="mTable-cell-wrap" style="visibility: hidden;">
            <span class="mTable-txt">{{ menu.title }}</span>
          </div>
        </li>
      </ul>
    </div>

    <!--普通列-->
    <div ref="mTableBody">
      <el-scrollbar ref="elScorller" class="whaty-scroll mTable-body myTableBody" wrap-class="whaty-scroll-wrap"
                    :style="{height: (tBodyHeight - 15) + 'px'}">
        <ul v-if="myTableData && myTableData.length > 0">
          <li
            v-for="(row, rowIndex) in myTableData"
            v-bind:class="[
              {'mTable-row-even': (rowIndex + 1) % 2 === 0},
              {'mTable-checkbox': rowChecks.length > 0},
              {'mTable-row-select': rowIsSelected(row.id)},
              {'mTable-row-hover': rowIndex === hoverRowIndex}
            ]"
            @click="handleRowClick(row.id)"
            @dblclick="handleRowDblClick(row)"
            @mouseover="handleRowMouseover(rowIndex)"
            @mouseout="handleRowMouseout(rowIndex)"
            class="mTable-row">
            <ul class="mTable-row-wrap clearfix">
              <!--行号(占位作用,被遮挡的)-->
              <li class="mTable-cell mTable-cell-first">
                <div class="mTable-cell-wrap">
                  <span class="mTable-num">{{ startIndex + rowIndex }}</span>
                  <label>
                    <div class="form-label form-label-single">
                      <input type="checkbox" v-model="rowChecks" v-bind:value="row.id">
                    </div>
                  </label>
                </div>
              </li>
              <!--左侧冻结行内按钮(占位作用,被遮挡的)-->
              <li v-for="menu in leftFixMenus"
                  :style="{width: tableMenuWidthMap[menu.text]+ 'px'}"
                  class="mTable-cell mTable-cell-medium">
                <div class="mTable-cell-wrap">
                  <span class="mTable-txt" v-html="getMenuRenderer(menu, row)"></span>
                </div>
              </li>
              <!--冻结列(占位作用,被遮挡的)-->
              <li
                v-for="(col, colIndex) in leftFixColumns"
                class="mTable-cell mTable-cell-medium"
                :class="getColumnClass(col)"
                :style="{width: (col.width ? col.width : tableColumnWidthMap[col.dataIndex]) + 'px'}"
              >
                <div class="mTable-cell-wrap">
                  <span v-if="col.isHtml" v-html="getAttribute(row, col.dataIndex, col)" class="mTable-txt"></span>
                  <span v-else class="mTable-txt">{{ getAttribute(row, col.dataIndex, col) }}</span>
                </div>
              </li>
              <!--左侧插槽行内按钮-->
              <slot name="bodyColumns" :row="row"></slot>
              <!--左侧非冻结行内按钮-->
              <li v-for="menu in leftUnfixMenus"
                  @click="handleMenuClick(menu, row)"
                  :style="{width: tableMenuWidthMap[menu.text]+ 'px'}"
                  class="mTable-cell mTable-cell-medium">
                <div class="mTable-cell-wrap">
                  <span class="mTable-txt" v-html="getMenuRenderer(menu, row)"></span>
                </div>
              </li>
              <!--非冻结列-->
              <li
                v-for="(col, colIndex) in myDragColumns"
                v-if="col.list && (col.show === undefined || col.show)"
                class="mTable-cell mTable-cell-medium"
                :style="{width: (col.width ? col.width : tableColumnWidthMap[col.dataIndex]) + 'px'}"
                :class="getColumnClass(col)"
                :title="getDisplayTitle(rowIndex, col)">
                <div class="mTable-cell-wrap">
                  <span v-if="col.isHtml" v-html="getDisplayValue(rowIndex, col)" class="mTable-txt"></span>
                  <span v-else class="mTable-txt" v-text="getDisplayValue(rowIndex, col)"></span>
                </div>
              </li>
              <!--右侧非冻结行内按钮-->
              <li v-for="menu in rightUnfixMenus"
                  @click="handleMenuClick(menu, row)"
                  :style="{width: tableMenuWidthMap[menu.text]+ 'px'}"
                  class="mTable-cell mTable-cell-medium">
                <div class="mTable-cell-wrap">
                  <span class="mTable-txt" v-html="getMenuRenderer(menu, row)"></span>
                </div>
              </li>
              <li class="mTable-cell" v-if="isShowChange(magicalMenuCodes)">
                <div class="mTable-cell-wrap">
                  <span class="mTable-txt">
                    <a @click="showDataHistory(row)" style="color: #677de0;cursor: pointer;">
                      查看数据历史
                    </a>
                  </span>
                </div>
              </li>
              <!--右侧插槽行内按钮-->
              <slot name="lastBodyColumns" :row="row"></slot>
              <!--右侧冻结行内按钮(占位作用,被遮挡的)-->
              <li v-for="menu in rightFixMenus"
                  :style="{width: tableMenuWidthMap[menu.text]+ 'px'}"
                  class="mTable-cell mTable-cell-medium">
                <div class="mTable-cell-wrap" style="visibility: hidden;">
                  <span class="mTable-txt" v-html="getMenuRenderer(menu, row)"></span>
                </div>
              </li>
            </ul>
          </li>
        </ul>
        <!--暂无数据提示-->
        <div v-else="" style="text-align: center;padding-top: 100px;">
          暂无数据
          <ul class="mTable-head-wrap clearfix">
            <li v-for="(column, i) in myDragColumns"
                v-if="column.list && (column.show === undefined || column.show)"
                :style="{width: (column.width ? column.width : tableColumnWidthMap[column.dataIndex]) + 'px'}">
            </li>
            <li v-for="menu in columnMenus" :style="{width: tableMenuWidthMap[menu.text] + 'px'}"></li>
          </ul>
        </div>
      </el-scrollbar>
    </div>

    <!--冻结列 table-->
    <div ref="mTableFix" class="mTable-fix">
      <!--table header-->
      <div class="mTable-head" style="overflow: hidden;">
        <ul class="mTable-head-wrap clearfix">
          <!--行号-->
          <li class="mTable-cell mTable-cell-first">
            <div class="mTable-cell-wrap">
              <label class="form-label form-label-tableHead">
                <input type="checkbox" v-model="allChecked" @click="handleAllCheckbox">
              </label>
            </div>
          </li>
          <!--左侧冻结行内按钮-->
          <li v-for="menu in leftFixMenus"
              :style="{width: tableMenuWidthMap[menu.text] + 'px'}"
              class="mTable-cell mTable-cell-medium">
            <div class="mTable-cell-wrap">
              <span class="mTable-txt">{{ menu.title }}</span>
            </div>
          </li>
          <!--左侧冻结列-->
          <li v-for="(column, i) in leftFixColumns"
              class="mTable-cell mTable-cell-medium grid-column"
              :class="getHeaderClass(column)"
              style="background-color: #ffffff"
              :style="{width: (column.width ? column.width : tableColumnWidthMap[column.dataIndex]) + 'px'}"
          >
            <div class="mTable-cell-wrap">
						<span @click="handleOrder(column)" :class="getColumnOrder(column)" class="mTable-txt">{{ column.name }}
							<span class="mTable-sort"><i class="mng icon-descending"></i></span>
						</span>
            </div>
          </li>
        </ul>
      </div>
      <!--table body-->
      <div ref="mTableFixBody" v-if="myTableData && myTableData.length > 0"
           class="mTable-body" style="overflow: hidden;" :style="{height: (tBodyHeight - 32) + 'px'}">
        <ul>
          <li
            v-for="(row, rowIndex) in myTableData"
            v-bind:class="[
              {'mTable-row-even': (rowIndex + 1) % 2 === 0},
              {'mTable-checkbox': rowChecks.length > 0},
              {'mTable-row-select': rowIsSelected(row.id)},
              {'mTable-row-hover': rowIndex === hoverRowIndex}
            ]"
            @click="handleRowClick(row.id)"
            @dblclick="handleRowDblClick(row)"
            @mouseover="handleRowMouseover(rowIndex)"
            @mouseout="handleRowMouseout(rowIndex)"
            class="mTable-row">
            <ul class="mTable-row-wrap clearfix">
              <!--行号-->
              <li class="mTable-cell mTable-cell-first">
                <div class="mTable-cell-wrap">
                  <span class="mTable-num">{{ startIndex + rowIndex }}</span>
                  <label>
                    <div class="form-label form-label-single">
                      <input type="checkbox" v-model="rowChecks" v-bind:value="row.id" @click.stop>
                    </div>
                  </label>
                </div>
              </li>
              <!--左侧冻结按钮-->
              <li v-for="menu in leftFixMenus"
                  @click="handleMenuClick(menu, row)"
                  :style="{width: tableMenuWidthMap[menu.text]+ 'px'}"
                  class="mTable-cell mTable-cell-medium">
                <div class="mTable-cell-wrap">
                  <span class="mTable-txt" v-html="getMenuRenderer(menu, row)"></span>
                </div>
              </li>
              <!--左侧冻结列-->
              <li
                v-for="(col, colIndex) in leftFixColumns"
                class="mTable-cell mTable-cell-medium"
                :class="getColumnClass(col)"
                :style="{width: (col.width ? col.width : tableColumnWidthMap[col.dataIndex]) + 'px'}"
                :title="getDisplayTitle(rowIndex, col)"
              >
                <div class="mTable-cell-wrap">
                  <span v-if="col.isHtml" v-html="getDisplayValue(rowIndex, col)" class="mTable-txt"></span>
                  <span v-else class="mTable-txt" v-text="getDisplayValue(rowIndex, col)"></span>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <!--右侧冻结-->
    <div ref="mTableFixRight" class="mTable-fix-right">
      <!--table header-->
      <div class="mTable-head" style="overflow: hidden;">
        <ul class="mTable-head-wrap clearfix">
          <!--右侧冻结行内按钮-->
          <li v-for="menu in rightFixMenus"
              :style="{width: tableMenuWidthMap[menu.text] + 'px'}"
              class="mTable-cell mTable-cell-medium">
            <div class="mTable-cell-wrap">
              <span class="mTable-txt">{{ menu.title }}</span>
            </div>
          </li>
        </ul>
      </div>
      <!--table body-->
      <div ref="mTableFixBodyRight" v-if="myTableData && myTableData.length > 0"
           class="mTable-body" style="overflow: hidden;" :style="{height: (tBodyHeight - 32) + 'px'}">
        <ul>
          <li
            v-for="(row, rowIndex) in myTableData"
            v-bind:class="[
              {'mTable-row-even': (rowIndex + 1) % 2 === 0},
              {'mTable-checkbox': rowChecks.length > 0},
              {'mTable-row-select': rowIsSelected(row.id)},
              {'mTable-row-hover': rowIndex === hoverRowIndex}
            ]"
            @mouseover="handleRowMouseover(rowIndex)"
            @mouseout="handleRowMouseout(rowIndex)"
            class="mTable-row">
            <ul class="mTable-row-wrap clearfix">
              <!--右侧冻结按钮-->
              <li v-for="menu in rightFixMenus"
                  @click="handleMenuClick(menu, row)"
                  :style="{width: tableMenuWidthMap[menu.text]+ 'px'}"
                  class="mTable-cell mTable-cell-medium">
                <div class="mTable-cell-wrap">
                  <span class="mTable-txt" v-html="getMenuRenderer(menu, row)"></span>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <div class="mTable-column-resize-proxy" ref="resizeProxy" v-show="resizeProxyVisible"></div>
  </div>
</template>
<script>
  import util from '../../libs/util'
  import {addClass, removeClass} from 'element-ui/src/utils/dom'
  import {addResizeListener, removeResizeListener} from 'element-ui/src/utils/resize-event'
  import Sortable from 'sortablejs'

  const paramsPatt = new RegExp('\\$\\{([a-z,A-Z,.,0-9]*)\\}', 'g')

  export default {
    name: 'grid-table',
    props: {
      gridConfig: {
        type: Object,
        default() {
          return {}
        }
      },
      magicalMenuCodes: {
        type: Array,
        default() {
          return null
        }
      },
      tableData: { // 数据
        type: Array,
        default() {
          return []
        }
      },
      tableDisplayData: { // 展示数据
        type: Array,
        default() {
          return []
        }
      },
      startIndex: {
        type: Number,
        default: 1
      },
      tBodyHeight: {
        type: Number,
        default: 200
      },
      menus: {
        type: Array,
        default() {
          return []
        }
      },
      tableColumnWidthMap: {
        type: Object,
        default() {
          return {}
        }
      },
      tableMenuWidthMap: {
        type: Object,
        default() {
          return {}
        }
      },
      showChangeHistory: {
        type: Boolean,
        default () {
          return undefined
        }
      },
      changeHistoryNamespace: {
        type: String
      }
    },
    data() {
      return {
        rowChecks: [], // 选择的行
        allChecked: false, // 是否全选
        orderItem: [], // 排序参数
        renderFunctionMap: {}, // 缓存render function, 避免每次new function
        draggingColumn: null,
        dragging: false,
        dragState: {},
        resizeProxyVisible: false,
        sortable: null,
        afterDragColumns: null,
        hoverRowIndex: -1, // 当前鼠标hover的行
        historyDrawId: null,
        historyDrawCurrentData: {},
        historyHeaders: null,
        historyNamespace: null
      }
    },
    mounted() {
      this.setDraggable()
      this.addGridScrollListener()
      addResizeListener(this.$refs.mTableBody, this.updateElScroller)
    },
    beforeDestroy() {
      removeResizeListener(this.$refs.mTableBody, this.updateElScroller)
    },
    computed: {
      myTableData: function () {
        return this.tableData
      },
      myDragColumns: function () { // list = true && show = true && no fix
        let tempColumns = []
        let columnList = this.afterDragColumns || this.gridConfig.listColumnConfig
        if (columnList && columnList.length > 0) {
          columnList.forEach(column => {
            if (column.list && column.fix !== 'left' && (column.show === undefined || column.show)) {
              tempColumns.push(column)
            }
          })
        }
        return tempColumns
      },
      leftFixColumns() { // 左侧冻结列
        let columns = []
        if (this.gridConfig.listColumnConfig && this.gridConfig.listColumnConfig.length > 0) {
          this.gridConfig.listColumnConfig.forEach(column => {
            if (column.list && column.fix === 'left' && (column.show === undefined || column.show)) {
              columns.push(column)
            }
          })
        }
        return columns
      },
      columnMenus() { // 行内按钮
        let menus = []
        if (this.gridConfig.gridMenuList && this.gridConfig.gridMenuList.length > 0) {
          this.gridConfig.gridMenuList.forEach(menu => {
            if (menu.showType === 'column' && menu.type !== 'magicalMenu') {
              menus.push(menu)
            }
          })
        }
        return menus
      },
      leftUnfixMenus() { // 左侧 非冻结 按钮
        let menus = []
        if (this.columnMenus.length > 0) {
          this.columnMenus.forEach(menu => {
            if (menu.columnType === 'left' || !menu.columnType || menu.columnType === '') {
              if (!menu.fix) {
                this.setMenuTitle(menu)
                menus.push(menu)
              }
            }
          })
        }
        return menus
      },
      leftFixMenus() { // 左侧 冻结 按钮
        let menus = []
        if (this.columnMenus.length > 0) {
          this.columnMenus.forEach(menu => {
            if (menu.columnType === 'left' || !menu.columnType || menu.columnType === '') {
              if (menu.fix) {
                this.setMenuTitle(menu)
                menus.push(menu)
              }
            }
          })
        }
        return menus
      },
      rightUnfixMenus() { // 右侧 非冻结 按钮
        let menus = []
        if (this.columnMenus.length > 0) {
          this.columnMenus.forEach(menu => {
            if (menu.columnType === 'right') {
              if (!menu.fix) {
                this.setMenuTitle(menu)
                menus.push(menu)
              }
            }
          })
        }
        return menus
      },
      rightFixMenus() { // 右侧 冻结 按钮
        let menus = []
        if (this.columnMenus.length > 0) {
          this.columnMenus.forEach(menu => {
            if (menu.columnType === 'right') {
              if (menu.fix) {
                this.setMenuTitle(menu)
                menus.push(menu)
              }
            }
          })
        }
        return menus
      }
    },
    methods: {
      setMenuTitle(menu) {
        let extendMenuConfig = menu.extendMenuConfig ? JSON.parse(menu.extendMenuConfig) : ''
        this.$set(menu, 'title', extendMenuConfig.menuTitle || menu.text)
      },
      updateElScroller() {
        this.$refs.elScorller.update()
      },
      handleScroll() {
        this.$refs.elScorller.handleScroll()
      },
      getAttribute(obj, key, col) {
        return util.getAttribute(obj, key, col)
      },
      getDisplayTitle(rowIndex, col) {
        let value = this.tableDisplayData[rowIndex] ? this.tableDisplayData[rowIndex][col.dataIndex] : ''
        return col.isHtml ? util.clearHtml(value) : value
      },
      getDisplayValue(rowIndex, col) {
        return this.tableDisplayData[rowIndex] ? this.tableDisplayData[rowIndex][col.dataIndex] : ''
      },
      getHeaderClass(column) {
        return column.dataColumn.replace(/\./g, '-')
      },
      getColumnClass(column) {
        return 'column-' + column.dataColumn.replace(/\./g, '-')
      },
      getColumnOrder(column) { // 获取列的排序方式
        for (let i = 0; i < this.orderItem.length; i++) {
          if (this.orderItem[i].dataIndex === column.dataIndex) {
            return this.orderItem[i].sort
          }
        }
        return ''
      },
      removeColumnOrder(column) {
        for (let i = 0; i < this.orderItem.length; i++) {
          if (this.orderItem[i].dataIndex === column.dataIndex) {
            this.orderItem.splice(i, 1)
            break
          }
        }
      },
      selectAllRow() { // 全选
        this.allChecked = true
        this.rowChecks = []
        this.tableData.map((item) => {
          this.rowChecks.push(item.id)
        })
      },
      clearRowChecks() { // 取消全选
        this.allChecked = false
        this.rowChecks = []
      },
      handleAllCheckbox(e) { // 处理全选checkbox事件
        if (e.target.checked) {
          this.selectAllRow()
        } else {
          this.clearRowChecks()
        }
      },
      handleRowClick(id) { // 处理行点击事件
        if (this.rowChecks.length > 0) { // 只在选择模式下才响应行点击事件
          let hasChecked = false
          for (let i = 0; i < this.rowChecks.length; i++) {
            if (this.rowChecks[i] === id) {
              this.rowChecks.splice(i, 1)
              hasChecked = true
              break
            }
          }
          if (!hasChecked) {
            this.rowChecks.push(id)
          }
        }
      },
      handleRowDblClick(row) {
        if (this.gridConfig.canUpdate) {
          this.$emit('row-dblclick', row.id)
        } else {
          this.$notify.error({title: '错误', message: '不支持双击修改！'})
        }
      },
      rowIsSelected(id) {
        for (let i = 0; i < this.rowChecks.length; i++) {
          if (this.rowChecks[i] === id) {
            return true
          }
        }
        return false
      },
      handleOrder(column) { // 点击列排序
        // 变换规则: 无序 - desc - asc
        let order = this.getColumnOrder(column)
        this.removeColumnOrder(column)
        if (!order) {
          this.orderItem.push({'dataIndex': column.dataIndex, 'sort': 'desc'})
        } else if (order === 'desc') {
          this.orderItem.push({'dataIndex': column.dataIndex, 'sort': 'asc'})
        } else {
        }
        this.$emit('order-item-change', this.orderItem)
      },
      gridScroll() {
        this.$refs.mTableHead.scrollLeft = this.$refs.mTableBody.querySelector('.whaty-scroll-wrap').scrollLeft
        if (this.$refs.mTableFixBody) {
          this.$refs.mTableFixBody.scrollTop = this.$refs.mTableBody.querySelector('.whaty-scroll-wrap').scrollTop
        }
        if (this.$refs.mTableFixBodyRight) {
          this.$refs.mTableFixBodyRight.scrollTop = this.$refs.mTableBody.querySelector('.whaty-scroll-wrap').scrollTop
        }
      },
      addGridScrollListener() {
        const self = this
        self.$refs.mTableBody.querySelector('.whaty-scroll-wrap').addEventListener('scroll', self.gridScroll)
      },
      getMenuRenderer(menu, row) {
        if (menu.type === 'scriptMenu') {
          return this.getScriptMenuRenderer(menu, row)
        }
        let dataIndex = menu.dataIndex || 'id'
        let value = this.getAttribute(row, dataIndex)
        if (value) {
          if (menu.type === 'toUrlMenu') {
            let url = menu.url.replace(/\$\{value\}/g, value)
            let result
            while ((result = paramsPatt.exec(url)) != null) {
              url = url.replace(result[0], this.getAttribute(row, result[1]))
            }
            return `<a href="${url}" target="${menu.openMode}" style="color: #677de0; cursor: pointer;">${menu.text}</a>`
          } else {
            return `<span style="color: #0000EE; cursor: pointer;">${menu.text}</span>`
          }
        } else {
          return menu.nullText
        }
      },
      getFunctionMenuRenderer(menu, row) {
        let renderer = menu.renderer
        let columnDataIndex = menu.columnDataIndex || 'id'
        let value = this.getAttribute(row, columnDataIndex) || ''
        renderer = renderer.replace(/\$\{value\}/g, value)
        return renderer
      },
      getScriptMenuRenderer(menu, row) {
        let template = menu.script
        let dataIndex = menu.dataIndex || 'id'
        let value = this.getAttribute(row, dataIndex) || ''
        // eslint-disable-next-line
        let parse = eval(util.compile(`${template}`))
        return parse({value: value, record: row})
      },
      handleMenuClick(menu, row) {
        if (menu.type !== 'toUrlMenu' && menu.type !== 'scriptMenu') {
          let dataIndex = menu.dataIndex || 'id'
          let id = this.getAttribute(row, dataIndex)
          if (id) {
            this.$emit('menu-click', menu, id, row)
          }
        }
      },
      handleGridMenuClick(gridMenu, row) {
        if (gridMenu.menuClick && typeof gridMenu.menuClick === 'function') {
          gridMenu.menuClick.call(this, gridMenu, row)
        }
      },
      getGridMenuRenderer(gridMenu, row) {
        if (gridMenu.menuRenderer && typeof gridMenu.menuRenderer === 'function') {
          return gridMenu.menuRenderer.call(this, gridMenu, row)
        }
        return gridMenu.name
      },
      handleMouseMove(event, column) {
        let target = event.target
        while (target && target.tagName !== 'LI') {
          target = target.parentNode
        }
        if (!this.dragging) {
          let rect = target.getBoundingClientRect()
          const bodyStyle = document.body.style
          if (rect.width > 12 && rect.right - event.pageX < 8) {
            target.style.cursor = 'col-resize'
            bodyStyle.cursor = 'col-resize'
            this.draggingColumn = column
            if (this.sortable) {
              this.sortable.options.disabled = true
            }
          } else {
            target.style.cursor = 'pointer'
            bodyStyle.cursor = ''
            this.draggingColumn = null
            if (this.sortable) {
              this.sortable.options.disabled = false
            }
          }
        }
      },
      handleMouseOut() {
        document.body.style.cursor = ''
      },
      handleMouseDown(event, column) {  // 拖动设置列表宽度
        if (this.draggingColumn) {
          this.dragging = true
          this.resizeProxyVisible = true
          const tableLeft = this.$el.getBoundingClientRect().left
          const columnEl = this.$el.querySelector('li.' + this.getHeaderClass(column))
          const columnRect = columnEl.getBoundingClientRect()
          const minLeft = columnRect.left - tableLeft + 30
          addClass(columnEl, 'noclick')
          this.dragState = {
            startMouseLeft: event.clientX,
            startLeft: columnRect.right - tableLeft,
            startColumnLeft: columnRect.left - tableLeft,
            tableLeft
          }
          const resizeProxy = this.$refs.resizeProxy
          resizeProxy.style.left = this.dragState.startLeft + 'px'
          document.onselectstart = function () {
            return false
          }
          document.ondragstart = function () {
            return false
          }
          const handleMouseMove = (event) => {
            const deltaLeft = event.clientX - this.dragState.startMouseLeft
            const proxyLeft = this.dragState.startLeft + deltaLeft
            resizeProxy.style.left = Math.max(minLeft, proxyLeft) + 'px'
          }
          const handleMouseUp = () => { // 释放鼠标回调方法
            if (this.dragging) {
              const {
                startColumnLeft
              } = this.dragState
              const finalLeft = parseInt(resizeProxy.style.left, 10)
              const columnWidth = finalLeft - startColumnLeft
              this.changeColumnWidth(column, columnWidth)
              document.body.style.cursor = ''
              this.dragging = false
              this.draggingColumn = null
              this.dragState = {}
              this.resizeProxyVisible = false
              if (this.sortable) {
                this.sortable.options.disabled = false
              }
            }
            document.removeEventListener('mousemove', handleMouseMove)
            document.removeEventListener('mouseup', handleMouseUp)
            document.onselectstart = null
            document.ondragstart = null
            setTimeout(function () {
              removeClass(columnEl, 'noclick')
            }, 0)
          }
          document.addEventListener('mousemove', handleMouseMove)
          document.addEventListener('mouseup', handleMouseUp)
        }
      },
      changeColumnWidth(column, width) { // 改变列宽
        // 外层包裹容器(宽度和窗口宽度一致)
        let elScrollerWrap = this.$refs.elScorller.$el.querySelector('.el-scrollbar__wrap')
        // 内容包裹容器(宽度和内容宽度一致)
        let elScrollerView = this.$refs.elScorller.$el.querySelector('.el-scrollbar__view')
        // 内部ul(实际内容)
        let innerUl = this.$refs.elScorller.$el.querySelector('ul.mTable-row-wrap')
        let elScrollerWrapWidth = elScrollerWrap.clientWidth
        let innerUlWidth = innerUl.clientWidth - this.tableColumnWidthMap[column.dataIndex] + width
        // 根据实际内容设置外层包裹容器的宽度,如果实际内容宽度小于视窗时取视窗宽度
        elScrollerView.style.width = Math.max(innerUlWidth, elScrollerWrapWidth) + 'px'
        // 设置宽度,改变冻结列等的宽度
        this.$set(this.tableColumnWidthMap, column.dataIndex, width)
        // 更新el-scrollerbar
        this.updateElScroller()
      },
      setDraggable() { // 设置表头拖动
        const headerEl = this.$el.querySelector('ul.mTable-head-wrap')
        this.sortable = Sortable.create(headerEl, {
          draggable: '.grid-column',
          onEnd: evt => {
            // 拖动结束后调整列顺序
            if (!this.afterDragColumns) {
              this.afterDragColumns = []
              let j = 0
              for (let i = 0; i < this.gridConfig.listColumnConfig.length; i++) {
                const columnConfig = this.gridConfig.listColumnConfig[i]
                if (columnConfig.list && !columnConfig.fix) {
                  this.afterDragColumns[j++] = this.gridConfig.listColumnConfig[i]
                }
              }
            }
            const tempColumn = this.afterDragColumns.splice(evt.oldIndex, 1)[0]
            this.afterDragColumns.splice(evt.newIndex, 0, tempColumn)
          }
        })
      },
      handleRowMouseover(rowIndex) {
        this.hoverRowIndex = rowIndex
      },
      handleRowMouseout(rowIndex) {
        this.hoverRowIndex = -1
      },
      isShowChange: function(menuCodes) {
        return this.showChangeHistory !== undefined ? this.showChangeHistory : menuCodes.indexOf('showChangeHistory') >= 0
      },
      showDataHistory: function(row) {
        let headers = this.convertHeaders()
        this.historyDrawId = row.id
        this.historyNamespace = this.changeHistoryNamespace ? this.changeHistoryNamespace : this.getNamespace('showChangeHistory')
        for (let i = 0; i < headers.length; i++) {
          this.$set(this.historyDrawCurrentData, headers[i].name, util.getAttribute(row, headers[i].dataIndex, headers[i]))
        }
        this.$emit('showChangeHistory', this.historyDrawId, this.historyNamespace, this.historyDrawCurrentData)
      },
      getNamespace: function(code) {
        let menus = this.gridConfig.gridMenuList
        for (let i = 0; i < menus.length; i++) {
          if (menus[i].type === 'magicalMenu') {
            let extendConfig = JSON.parse(menus[i].extendMenuConfig)
            if (extendConfig.code === code) {
              return extendConfig.namespace
            }
          }
        }
        return null
      },
      convertHeaders: function() {
        if (this.historyHeaders === null) {
          let headers = []
          let originHeaders = this.gridConfig.listColumnConfig
          for (let i = 0; i < originHeaders.length; i++) {
            if (originHeaders[i].list) {
              let dataIndex = originHeaders[i].dataIndex
              if (dataIndex.indexOf('combobox_') >= 0) {
                dataIndex = dataIndex.substring(dataIndex.indexOf('.') + 1)
              }
              let header = {...originHeaders[i]}
              header.dataIndex = dataIndex
              headers.push(header)
            }
          }
          this.historyHeaders = headers
        }
        return this.historyHeaders
      }
    },
    watch: {
      rowChecks: function () { // 选中行数变化时通知父组件
        this.allChecked = this.rowChecks.length !== 0 && this.rowChecks.length === this.myTableData.length
        this.$emit('checked-row-change', this.rowChecks)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/grid/grid-table.vue